// Box score helpers for the players of a match

const ASSETS_URL = 'https://storage.googleapis.com'

export function getStats(player) {
    return (player && Array.isArray(player.stats) && player.stats[0]) || {}
}

const num = value => Number(value) || 0

// Every foul of a player, as the team fouls count them: personal, technical, disruptive, flagrant (the technical
// fouls of the coach and of the bench are on the team, with no player, and are not team fouls)
export function foulsOf(stats = {}) {
    // the unsportsmanlike foul before FIBA 2026, the disruptive (DI) and the flagrant (FL) one after
    return num(stats.personalFouls) + num(stats.technicalFouls) + num(stats.unsportsmanlikeFouls) +
        num(stats.disruptiveFouls) + num(stats.flagrantFouls)
}

// PIR as the backend stores it; worked out from the box score when missing
export function getPir(stats = {}) {
    const direct = Number(stats.pir)
    if (stats.pir !== null && stats.pir !== undefined && Number.isFinite(direct)) return direct
    const missedFg = num(stats.twoPointAttempts) + num(stats.threePointAttempts) - num(stats.twoPointsMade) - num(stats.threePointsMade)
    const missedFt = num(stats.freeThrowAttempts) - num(stats.freeThrowsMade)
    return (num(stats.points) + num(stats.rebounds) + num(stats.assists) + num(stats.steals) + num(stats.blockedShots)) -
        (missedFg + missedFt + num(stats.turnovers) + num(stats.personalFouls) + num(stats.technicalFouls))
}

export function hasPlayerStats(player) {
    const stats = player && Array.isArray(player.stats) && player.stats[0]
    if (!stats) return false
    if (num(stats.playTimeInSecs) > 0) return true
    const fields = [
        'points', 'twoPointAttempts', 'threePointAttempts', 'freeThrowAttempts', 'offensiveRebounds', 'defensiveRebounds',
        'rebounds', 'assists', 'steals', 'turnovers', 'blockedShots', 'personalFouls', 'pir'
    ]
    return fields.some(field => num(stats[field]) !== 0)
}

export function getPlayerImage(player, fallback) {
    const raw = player && (player.image || player.photo || player.avatar || player.imageUrl)
    if (!raw) return fallback
    if (/^https?:\/\//i.test(raw)) return raw
    return `${ASSETS_URL}/${raw}`
}

// "Β. Παπαγγελάκης"
export function getShortName(player = {}) {
    const surname = player.surname || player.lastName || ''
    const name = player.name || player.firstName || ''
    if (!surname) return name || 'Παίκτης'
    return name ? `${name.charAt(0)}. ${surname}` : surname
}

export function getJersey(player = {}) {
    const jersey = player.alternativeJersey ?? player.jersey
    return jersey === null || jersey === undefined || jersey === '' ? null : jersey
}

export function percentage(made, attempts) {
    return attempts ? Math.round((made / attempts) * 100) : 0
}

export function formatMinutes(secs) {
    const value = Number(secs)
    if (!Number.isFinite(value) || value <= 0) return '-'
    const minutes = Math.floor(value / 60)
    const seconds = Math.floor(value % 60)
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
}
